import { Link } from "gatsby"
import React, { useContext } from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { StaticImage } from "gatsby-plugin-image"

import styled from "styled-components"

import WebriQForm from "@webriq/gatsby-webriq-form"

const Banner = () => {
  return (
    <>
      <div className="hero-new-study">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mx-auto">
              <div className="title-banner">
                <h1 className="text-center">
                  Custom Quickbase ERP Replaces 18 Legacy Systems at Major U.S.
                  Port
                </h1>
                <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-sm-start text-center text-sm-left text-white">
                  <p className="pr-sm-1 mb-1 mb-sm-0">
                    <strong>Summary:</strong>
                  </p>
                  <p>
                    After merging three operators, a major U.S. port ran 18
                    disconnected systems that slowed billing, scheduling, and
                    asset tracking. Quandary built a custom ERP with Quickbase
                    to improve vessel ops and cut billing time from 10 days to
                    48 hours.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 24px;
  padding: 24px 0;
`

const LogoCard = styled.div`
  background: #fff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  min-width: 160px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  padding: 12px;
`

const LogoImg = styled.img`
  max-width: 100%;
  max-height: 48px;
  object-fit: contain;
`

const Custom = ({ location }) => {
  return (
    <>
      <Layout banner={<Banner />} location={location}>
        <Seo
          title="Custom Quickbase ERP Replaces 18 Legacy Systems at Major U.S. Port"
          description="After a port merger left 18 systems in place, Quandary built a Quickbase ERP to unify ops, improve vessel scheduling, and cut billing to 48 hours."
        />
        <div className="py-4 py-md-5 case-studies-inner new-case-studies-inner bg-white">
          <div className="container">
            <div className="row">
              <div className="col-md-4 col-lg-4">
                <div
                  className="sidebar-tab relative results"
                  style={{ position: "sticky", top: "110px" }}
                >
                  <div className="relative results bg-case-study p-4">
                    <h3 className="mt-0 ">Results Snapshot</h3>
                    <ul className="ml-0">
                      <li>Billing cycle cut from 10 days to 48h</li>
                      <li>Real-time dashboards used daily</li>
                      <li>Union labor scheduling centralized</li>
                      <li>Asset loss reduced with scanner tracking</li>
                      <li>Vehicle maintenance now automated</li>
                    </ul>
                  </div>
                  <a
                    className="btn btn-primary btn-arrow mr-2 mt-4 text-center relative w-full"
                    download
                    target="_blank"
                    href="https://cdn.sanity.io/files/55lcecww/production/edb7931bfa4ae60cb8d106fc7bb223cd9fc1706a.pdf"
                  >
                    Download This Story
                  </a>
                </div>
              </div>
              <div className="col-md-8 col-lg-8">
                <section className="relative">
                  <div className="relative px-0">
                    <div className="row mx-0">
                      <div className="col-md-11 mx-auto p-4 content-wrapper">
                        <div className="client-content">
                          <h2>The Challenge</h2>
                          <p>
                            After merging three port operators, the client was
                            running 18 disconnected systems that couldn’t scale.
                            Every terminal had its own tools, workflows, and
                            blind spots, making it nearly impossible to
                            coordinate labor, equipment, and cargo to keep
                            vessels moving.
                          </p>
                          <p>
                            Teams relied on spreadsheets, phone calls, and
                            manual tracking just to move containers and schedule
                            crews. Basic reports took days. Billing dragged for
                            a week or more. And every delay slowed vessel
                            turnaround, tied up resources at the gates, and cost
                            revenue.
                          </p>
                          <p>
                            Leadership knew the current setup couldn’t keep
                            pace.{" "}
                            <Link to="/quickbase-integration-services">
                              They needed a unified system
                            </Link>{" "}
                            that could support real-time decisions without
                            halting day-to-day operations.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper bg-grey">
                        <div className="client-content">
                          <h2>Our Solution</h2>
                          <p>
                            <Link to="/">Quandary Consulting Group</Link> built
                            a custom ERP system with{" "}
                            <Link to="/partners/quickbase/">Quickbase</Link> to
                            unify scheduling, logistics, labor management, and
                            asset tracking across the port. This replaced the
                            client’s disconnected spreadsheets, emails, and
                            legacy systems with a single operational platform.
                          </p>
                          <p>
                            The scope included applications for workforce
                            scheduling, container movement, inventory control,
                            asset check-in and check-out, and preventative
                            maintenance logging. All workflows were tailored to
                            reflect how port teams actually worked in the field.
                          </p>
                          <p>
                            <Link to="/">Low-code development</Link> built
                            enabled fast and adaptable delivery under real
                            operational pressure. The platform allowed us to
                            build quickly, adapt to feedback, and avoid the long
                            delays and overhead associated with traditional
                            software development.
                          </p>

                          <p>
                            <strong>Key Features:</strong>
                          </p>
                          <ul className="pl-4">
                            <li>
                              <strong>Executive Dashboard: </strong>Gives
                              leadership a live view of vessel schedules,
                              throughput, and terminal activity to make faster
                              decisions across the port.
                            </li>
                            <li>
                              <strong>
                                Terminal Operation Reports (TOR):{" "}
                              </strong>
                              Automatically pulls data into a standardized
                              format aligned with billing, reducing manual
                              reporting time.
                            </li>
                            <li>
                              <strong>
                                Labor and Scheduling Integration:{" "}
                              </strong>
                              Manages union workflows in one system to avoid
                              conflicts and delays.
                            </li>
                            <li>
                              <strong>Shift-Level Production Logging: </strong>
                              Tracks AOMs and container moves for supervisors in
                              real time without lag.
                            </li>
                            <li>
                              <strong>Asset Tracking: </strong>
                              Teams check equipment check-in/out via scanner,
                              cutting loss, duplication, and downtime.
                            </li>
                            <li>
                              <strong>
                                Preventative Maintenance Tracker:{" "}
                              </strong>
                              Schedules port vehicle maintenance to prevent
                              breakdowns that cause delays.
                            </li>
                            <li>
                              <strong>Operational Scorecard: </strong>
                              Aggregates performance data across vessels and
                              terminals to highlight trends and identify areas
                              for improvement.
                            </li>
                            <li>
                              <strong>ERP Integration: </strong>
                              Syncs operations data directly with NetSuite to
                              eliminate double entry and speed up billing.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper">
                        <div className="client-content">
                          <h2>Our Process</h2>
                          <p>
                            We delivered the system{" "}
                            <Link to="/our-approach">in two-week sprints,</Link>{" "}
                            starting with the areas causing the most operational
                            friction. The client stayed deeply involved
                            throughout: testing, validating, and shaping each
                            release based on real-world use.
                          </p>
                          <p>
                            <strong>Key Steps:</strong>
                          </p>
                          <ol className="decimal">
                            <li>
                              Mapped the client's infrastructure, data flows,
                              and operational pain points through a full
                              discovery
                            </li>
                            <li>
                              Used the legacy system as a reference to decide
                              what to rebuild, redesign, or eliminate
                            </li>
                            <li>
                              Built each Quickbase app with direct input from
                              field teams, supervisors, and managers
                            </li>
                            <li>
                              Focused initial sprints on high-friction tasks
                              like production logging and workforce scheduling
                            </li>
                            <li>
                              Validated each release through live walkthroughs
                              and on-site feedback before moving to the next
                              phase
                            </li>
                            <li>
                              Added new modules based on what surfaced during
                              real usage, not just upfront planning
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper bg-gradient">
                        <div className="client-content">
                          <h2 className="text-white">The Roadblocks</h2>
                          <p className="text-white">
                            Rolling out new workflows in a busy port environment
                            meant asking dozens of people to change their work
                            processes, all while vessels were still in
                            operation. Each application affected day-to-day
                            tasks, and adoption required hands-on support to
                            take hold.
                          </p>
                          <p className="text-white">
                            We worked directly with supervisors and field
                            managers during onboarding. That included building
                            walkthroughs, creating process guides, and adjusting
                            tools based on how they were actually used in the
                            field.
                          </p>
                          <p className="text-white">
                            The technical environment added another layer of
                            complexity. The port relied on 18 separate systems
                            with overlapping data, conflicting fields, and
                            inconsistent formats. We had to connect the right
                            sources without creating duplication, drift, or
                            extra manual work.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper">
                        <div className="client-content">
                          <h2>The Toolstack</h2>
                          <LogoGrid>
                            <LogoCard>
                              <LogoImg
                                src="https://cdn.sanity.io/images/55lcecww/production/78673169bfad856d32e060c5bf029890db184c60-261x101.png"
                                alt="Quickbase"
                              />
                            </LogoCard>
                            <LogoCard>
                              <LogoImg
                                src="https://cdn.sanity.io/images/55lcecww/production/3b4e20bdf79154551e98f711f2a18ea15f3f1fe7-261x101.png"
                                alt="Quickbase"
                              />
                            </LogoCard>
                            <LogoCard>
                              <LogoImg
                                src="https://cdn.sanity.io/images/55lcecww/production/1716d37ece5d020b05de6ab69b82bb2b4871a9bc-261x101.png"
                                alt="Quickbase"
                              />
                            </LogoCard>
                          </LogoGrid>
                          <ul className="pl-4">
                            <li>
                              <strong>Quickbase: </strong>
                              Core low-code platform used to build all
                              operational apps, from scheduling to maintenance,
                              enabling rapid development and field-driven
                              iteration
                            </li>
                            <li>
                              <strong>Azure: </strong>
                              Provided secure, scalable infrastructure to
                              support integrations and data flow between tools
                            </li>
                            <li>
                              <strong>peakSUITE Document Generator: </strong>
                              Automated Terminal Operation Reports using live
                              data, eliminating manual formatting and delays
                            </li>
                          </ul>
                          <p className="pt-4">
                            <strong>Integrated with:</strong>
                          </p>
                          <LogoGrid>
                            <LogoCard>
                              <LogoImg
                                src="https://cdn.sanity.io/images/55lcecww/production/7c32b5ace8f2cd5cdc400c0d33dd462f101a7257-261x101.png"
                                alt="Quickbase"
                              />
                            </LogoCard>
                            <LogoCard>
                              <LogoImg
                                src="https://cdn.sanity.io/images/55lcecww/production/99204943e879ab1856da694524ef53086e81ac36-261x101.png"
                                alt="Quickbase"
                              />
                            </LogoCard>
                            <LogoCard>
                              <LogoImg
                                src="https://cdn.sanity.io/images/55lcecww/production/4f71756e6e6e505a734541293a11c4e2233acc55-261x101.png"
                                alt="Quickbase"
                              />
                            </LogoCard>
                          </LogoGrid>
                          <ul className="pl-4">
                            <li>
                              <strong>Oracle NetSuite: </strong>
                              Synced operational data into the ERP to reduce
                              re-entry and speed up billing
                            </li>
                            <li>
                              <strong>TCP Software: </strong>
                              Pulled in timekeeping data to improve labor
                              scheduling and shift-level accuracy
                            </li>
                            <li>
                              <strong>Power BI: </strong>
                              Visualized real-time port performance for exec
                              teams, turning raw data into fast decisions.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper bg-blue">
                        <div className="client-content">
                          <h2 className="text-white">The Results</h2>
                          <p className="text-white">
                            The new system gave the client real-time visibility
                            and control across daily port operations. Tasks that
                            once required days of emails, spreadsheets, and
                            phone calls now occur on a single platform with live
                            dashboards and automated workflows much faster.
                          </p>
                          <p className="text-white">
                            Billing cycles were reduced from 7–10 days to under
                            48 hours. Time entry and union labor scheduling are
                            managed in a single, connected system. Supervisors
                            log equipment usage and AOMs directly, cutting
                            errors and manual rework.
                          </p>
                          <p className="text-white">
                            Preventive maintenance is now automated for hundreds
                            of vehicles. Equipment is scanned in and out,
                            reducing duplication and loss. Leadership can track
                            operational trends across terminals and seasons to
                            make faster, more informed decisions.
                          </p>
                          <p>
                            <strong className="text-white">Key Results:</strong>
                          </p>
                          <ol className="decimal text-white">
                            <li className="text-white">
                              Cut billing time from 10 days to under 48 hours
                            </li>
                            <li className="text-white">
                              Reduced asset loss through scanner-based tracking
                            </li>
                            <li className="text-white">
                              Centralized union labor scheduling
                            </li>
                            <li className="text-white">
                              Automated vehicle maintenance across the port
                            </li>
                            <li className="text-white">
                              Real-time dashboards improved executive decisions
                            </li>
                            <li className="text-white">
                              Surfaced performance trends across terminals and
                              seasons
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div
                        className="col-md-11 mx-auto p-4 p-4 content-wrapper bg-grey"
                        style={{ marginTop: "30px" }}
                      >
                        <div className="client-content">
                          <h2>Client Overview:</h2>
                          <p>
                            A stevedoring and port services provider operating
                            at one of the busiest container ports in the United
                            States. The client manages vessel operations, cargo
                            handling, and gate services across multiple
                            terminals.
                          </p>
                          <div className="row align-items-center">
                            <div className="pl-4">
                              <p>
                                <strong>Industry:</strong> Marine terminal
                                operations and logistics
                                <span className="relative d-block">
                                  <strong>Location:</strong> Southeastern United
                                  States
                                </span>
                                <span className="relative d-block">
                                  <strong>Size:</strong> 200-500 employees
                                </span>
                              </p>
                            </div>

                            {/* <div className="col-md-6 pl-md-4 d-flex justify-content-center align-items-center border-left-md">
                              <LogoGrid>
                                <LogoCard>
                                  <LogoImg
                                    src="https://cdn.sanity.io/images/55lcecww/production/d4897c4eff3af5ae876b523c7a21bdfeffdd0e4c-1575x357.png"
                                    alt="Quickbase"
                                  />
                                </LogoCard>
                              </LogoGrid>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto px-0 pt-4 content-wrapper">
                        <div className="client-content">
                          <div id="speak-with-specialist">
                            <div className="form-wrap-contact">
                              <div className="form-wrapper">
                                <div className="intro mb-2">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <h2 className="mt-0 font-weight-medium">
                                        Speak with Our Innovation Team
                                      </h2>
                                      <p>
                                        Use the form below to drop us an e-mail.
                                        We'll be in touch shortly.
                                      </p>
                                      <small className="text-red">
                                        Fields marked with an asterisk (*) are
                                        required.
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <WebriQForm
                                  id="contact-form"
                                  name="Contact Form"
                                  className="contactForm"
                                  data-form-id="4d46fe65-4d66-46b4-946c-e5826349ed3c"
                                  data-thankyou-url="/thank-you"
                                >
                                  <div className="row">
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                      {/* <p class="required">Full Name</p> */}

                                      <input
                                        type="text"
                                        name="Full Name"
                                        size={40}
                                        className="form-control required"
                                        placeholder="Full Name *"
                                        aria-label="Full Name"
                                        required
                                        id="requiredField"
                                      />
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mt-4 mt-lg-0">
                                      {/* <p class="required">Phone</p> */}
                                      <input
                                        type="text"
                                        name="Phone"
                                        size={40}
                                        // minLength={14}
                                        className="form-control required"
                                        id="phone"
                                        placeholder="Phone Number *"
                                        aria-label="Phone"
                                        required
                                      />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
                                      {/* <p class="required">Email</p> */}
                                      <input
                                        type="email"
                                        name="Email"
                                        size={40}
                                        className="form-control"
                                        aria-label="Email"
                                        placeholder="Email *"
                                        required
                                      />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
                                      {/* <p class="required">Message</p> */}
                                      <textarea
                                        name="Message"
                                        rows={5}
                                        cols={0}
                                        className="form-control"
                                        aria-label="Message"
                                        placeholder="Message *"
                                        required
                                      />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
                                      {/* <p class="required">How did you find out about us?</p> */}
                                      <div>
                                        <textarea
                                          type="text"
                                          name="How did you find out about us?"
                                          size={40}
                                          rows={5}
                                          className="form-control"
                                          aria-label="How did you find out about us?"
                                          placeholder="How did you find out about us? *"
                                          required
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="form-group col-12 d-flex justify-content-start captcha-wrap">
                                      <div className="webriq-recaptcha" />
                                    </div>
                                    <div className="form-group col-12 text-left">
                                      <div className="input-filled">
                                        <button
                                          type="submit"
                                          className="btn btn-primary btn-arrow"
                                        >
                                          SUBMIT
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </WebriQForm>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default Custom
